import { SpinResponse } from '@cgs/data-access';
import { CgsEvent } from '@cgs/wge';
import { ResponseHolder } from '../response_holder';
import { BaseGameState } from '../states/base_game_state';
import { RequestState } from '../states/request_state';
import { BaseGameRule } from './infra/base_game_rule';

export class BeginRespinToAccelerate<
  TResponse extends SpinResponse,
> extends BaseGameRule<TResponse> {
  constructor(sourceState: BaseGameState<TResponse>, responseHolder: ResponseHolder<TResponse>) {
    super(sourceState, responseHolder);
  }

  dispatchEvent(_event: CgsEvent): void {
    this.triggered = this.ruleCondition(this.responseHolder) && this.sourceState.isFinished;
  }

  ruleCondition(_responseHolder: ResponseHolder<TResponse>): boolean {
    return true;
  }

  setActive(active: boolean): void {
    if (active) {
      const target = this.targetState as RequestState<TResponse>;
      if (target) {
        target.skipNetworkRequest = true;
      }
    }
    this.triggered = false;
  }

  update(_dt: number): void {
    this.triggered = this.ruleCondition(this.responseHolder) && this.sourceState.isFinished;
  }
}
